<template>
    <modal-survey :active="active" :theme="theme" :close="hideModal" :onCreateResult="createResult" />
</template>
<script>
import ModalSurvey from './ModalSurvey.vue';
import { getSurvey, createResult } from '../../../services/api/survey';
import { onMounted } from 'vue';

export default {
    data() {
        return {
            active: false,
            theme: ""
        }
    },
    name: 'modal-survey-container',
    components: {
        ModalSurvey,
    },
    methods: {
        hideModal() {
            this.createResult();
        },
        getTheme() {
            getSurvey()
                .then((res) => {
                    this.theme = res.data.theme;
                    if (this.theme === undefined)
                        this.active = false;
                    else
                        this.active = true;
                })
                .catch(() => {
                    this.active = false;
                });
        },
        createResult(value) {
            createResult(value);
            this.active = false;
        }
    },
    mounted() {
        console.log("========================================")
        console.log("Created")
        this.getTheme();
    }
}
</script>


// WEBPACK FOOTER //
// ModalSurveyContainer.vue?5baad807